import { useEffect, useState } from 'react'
import { useQuery } from '@apollo/client'
import { useParams, useNavigate } from 'react-router-dom'
import { Container, Box, Typography, Paper, Alert } from '@mui/material'

import { queries } from '../../graphql'
import { LinearProgress } from '../../components'
import { useAuth } from '../../hooks'
import { ClaimFundNewUser } from './claim-fund-new-user'
import { ClaimFundExistingUser } from './claim-fund-existing-user'
import { ClaimFundInvalid } from './claim-fund-invalid'

export function ClaimFund() {
  const { token } = useParams()
  const navigate = useNavigate()
  const [{ isLoggedIn }] = useAuth()
  const [showExistingUserFlow, setShowExistingUserFlow] = useState(false)

  const { data: validationData, loading: validating } = useQuery(queries.fundClaims.validateFundClaimToken, {
    variables: { token },
  })

  const { data: detailsData, loading: loadingDetails } = useQuery(queries.fundClaims.getFundClaimDetails, {
    variables: { token },
    skip: !token || validationData?.validateFundClaimToken !== 'valid',
  })

  const tokenStatus = validationData?.validateFundClaimToken
  const claimDetails = detailsData?.getFundClaimDetails

  // Determine which flow to show based on account status
  useEffect(() => {
    if (claimDetails) {
      // If account is already activated (has password), show existing user flow
      // If user is logged in, also show existing user flow
      if (claimDetails.isActivatedAccount || isLoggedIn) {
        setShowExistingUserFlow(true)
      } else {
        setShowExistingUserFlow(false)
      }
    }
  }, [claimDetails, isLoggedIn])

  if (validating || loadingDetails) {
    return <LinearProgress />
  }

  // Handle invalid tokens
  if (tokenStatus !== 'valid') {
    return <ClaimFundInvalid status={tokenStatus} />
  }

  if (!claimDetails) {
    return <ClaimFundInvalid status="invalid" />
  }

  // Show appropriate flow based on authentication state
  if (showExistingUserFlow) {
    return (
      <ClaimFundExistingUser
        token={token}
        claimDetails={claimDetails}
        onSwitchToNewUser={() => setShowExistingUserFlow(false)}
      />
    )
  }

  return (
    <ClaimFundNewUser
      token={token}
      claimDetails={claimDetails}
      onSwitchToExistingUser={() => setShowExistingUserFlow(true)}
    />
  )
}
